import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { SimpleField, TextAreaField, WideField } from "../../common/Inputs";
import { PhoneInput } from '../../common/PhoneInput';
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { agents } from '../../../constants/settingTypes';
import { parsePhoneNumber, required as phoneRequired, validate as validatePhone } from '../../../extensions/phoneHelper';
const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }

    required('Name');
    required('ContactPerson');    

    const { Phone } = values;
    if (props.initialValues.Phone === Phone)
        return errors;

    const phoneError = phoneRequired(Phone) || validatePhone(Phone);
    if (phoneError)
        errors.Phone = phoneError;
    return errors;
}

let EditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit(values) {
        values.Phone = parsePhoneNumber(values.Phone);        
        this.props.onSubmit(values);
    }

    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новый агент' : 'Редактирование агента'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>    
                        <Field name='Name' component={SimpleField} label='Название агента' />
                        <Field name='Phone' component={PhoneInput} label='Телефон' />
                        <Field name='ContactPerson' component={SimpleField} label='Контактное лицо' />
                        <Field name='Description' component={TextAreaField} label='Описание' />                       
                        <Field name='IsActive' component={WideField} label='Действует?' type='checkbox' />

                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

EditModal = reduxForm({
    form: 'agentEdit',
    validate, 
})(EditModal);

EditModal = connect(state => ({
    fetching: state.application.get('settings')[agents].updateFetching,
    crudError: state.application.get('settings')[agents].updateError
}))(EditModal);

export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/agents/EditModal.jsx